import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import theme from 'src/theme';

const ProductDetailCourseStyle = withTheme(styled.div``);

export default ProductDetailCourseStyle;
